module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_PIRITE_VERTICALE.bcb83947.webp";